import styled from 'styled-components';
import { colors } from 'styles/colors';

export const SummaryValueSpan = styled.span`
  text-align: right;
`;

export const SummaryRow = styled.span`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
`;

export const TotalRow = styled(SummaryRow)`
  margin-top: 10px;
  color: ${colors.violetElite};
  font-weight: 700;
  font-size: 20px;
`;
